import {SELECT_TAB }from './types'



export const selectTab = () => {
    return {
        type: SELECT_TAB,
    };
};


















